module.exports = __webpack_public_path__ + "img/5.d7d9183f.png";